import "../assets/css/style.css"
import "../assets/css/carousel.css"
import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import image1 from '../assets/img/teste1.jpg'
import image2 from '../assets/img/teste2.jpg'
import image3 from '../assets/img/teste3.jpg'
function ComponentCarousel() {
  return (
    <Carousel>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={image1}
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>Transporte rodoviário de carga</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={image2}
          alt="Second slide"
        />
        <Carousel.Caption>
          <h3>Transporte intermunicipal, interestadual e internacional</h3>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src={image3}
          alt="Third slide"
        />
        <Carousel.Caption>
          <h3>Movimentação interna de contêineres</h3>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default ComponentCarousel;